export default { 
 common: { 
 unit: 'USDT', 
 day: 'روز', 
 week: 'هفته', 
 save: 'ذخیره', 
 submit: 'ارسال', 
 confirmtitle: 'تایید عملیات', 
 confirm: 'تایید', 
 reset: 'بازنشانی', 
 refresh: 'تازه کردن', 
 copy: 'کپی', 
 copysuccessful: 'کپی موفق', 
 modify: 'تغییر', 
 binding: 'بند نشانی', 
 finished: 'انجام شد', 
 canceled: 'لغو شد', 
 cancel: 'لغو', 
 all: 'همه', 
 back: 'بازگشت', 
 loading: 'در حال بارگذاری...', 
 nomore: 'همه سوابق', 
 errortxt: 'بارگذاری شکست', 
 loosing: 'باز کردن برای تازه کردن...', 
 pulling: 'کشیدن برای تازه کردن...', 
 nodata: 'همچنان سوابقی وجود ندارد', 
 buy: 'خرید', 
 buyup: 'خرید بالا', 
 buydown: 'خرید پایین', 
 sell: 'فروش', 
 forserver: 'با پشتیبانی تماس بگیرید', 
 total: 'جمع', 
 status1: 'در انتظار بررسی ', 
 status2: 'انجام شد ', 
 status3: 'رد شد', 
 paytype1:'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'تحویل بانکی', 
 }, 
 footer: { 
 home: 'صفحه اصلی', 
 market: 'سوق', 
 exchange: 'تبادل ارز دیجیتال', 
 options: 'گزینه ها', 
 assets:'دارایی ها', 
 change: 'انتقال', 
 recharge: 'پر کردن', 
 withdrawal: 'کشیدن' 
 }, 
 home: { 
 menu1:'تجارت گزینه ها', 
 menu1desc: 'پشتیبانی از BTC/USDT و غیره', 
 menu2: 'پر کردن سریع', 
 menu3: 'کشیدن', 
 menu4: 'پشتیبانی آنلاین', 
 menu5: 'تبادل سریع', 
 menu6: 'وام کمک', 
 menu7: 'کان کردن قفل', 
 menu8: 'رهن', 
 menu9: 'انتقال حساب', 
 ranktitle: 'لیست افزایش', 
 name: 'نام', 
 price: 'قیمت جدید', 
 risefall: 'افزایش یا کاهش', 
 }, 
 register: { 
 register: 'ثبت نام', 
 login: 'ورود', 
 email: 'ایمیل', 
 phone: 'شماره تلفن', 
 accountplaceholder: 'لطفا حساب وارد کنید', 
 emailplaceholder: 'لطفا ایمیل وارد کنید', 
 phoneplaceholder: 'لطفا شماره تلفن وارد کنید', 
 pwdplaceholder:'لطفا رمز عبور وارد کنید', 
 pwdplaceholder1:'رمز عبور باید ۶ تا ۲۰ حرف یا رقم باشد', 
 agepwdplaceholder: 'لطفا رمز عبور را دوباره وارد کنید', 
 agepwdplaceholder1: 'رمز عبور های وارد شده مطابقت ندارند', 
 invitecodeplaceholder: 'لطفا کد دعوت وارد کنید', 
 remember: 'مرا به یاد داشته باش', 
 fotget: 'رمز عبور فراموش شده' 
 }, 
 market:{ 
 title: 'سوق', 
 all: 'همه' 
 }, 
 member:{ 
 reputation:'امتیاز اعتبار', 
 identity_authentication:'تایید هویت', 
 under_review:'در حال بررسی', 
 certified:'تایید شده', 
 awaiting_certification:'در انتظار تایید', 
 binding_withdrawal_address: 'بند نشانی کشیدن', 
 currently_selected_currency:'ارز انتخاب شده فعلی', 
 withdrawal_address:'نشانی کشیدن', 
 sharing_link:'لینک اشتراک من', 
 my_promotion_code:'کد تبلیغاتی من', 
 promotion_code:'کد تبلیغاتی', 
 system_message:'پیام سیستم', 
 night_mode:'حالت شب', 
 security_center:'مرکز امنیتی', 
 seted: 'تنظیم شده', 
 noset: 'تنظیم نشده', 
 login_password:'رمز عبور ورود', 
 transaction_password:'رمز عبور کشیدن', 
 app_download:'دانلود اپلیکیشن', 
 log_out:'خروج', 
 aboutus: 'درباره ما' 
 }, 
 identity:{ 
 title: 'تایید هویت', 
 name: 'نام', 
 nameplaceholder: 'لطفا نام واقعی خود را وارد کنید', 
 uploader: 'آپلود عکس شناسنامه', 
 tip1: 'آپلود جناح جلو شناسنامه', 
 tip2: 'آپلود جناح عقب شناسنامه' 
 }, 
 address: { 
 title: 'بند نشانی کشیدن', 
 bType: 'ارز انتخاب شده فعلی', 
 address: 'نشانی کشیدن', 
 addressplaceholder:'لطفا نشانی کشیدن وارد کنید', 
 }, 
 security:{ 
 title: 'مرکز امنیتی', 
 modifypwd: 'رمز عبور ورود', 
 resetlegalpwd: 'رمز عبور کشیدن', 
 loginpwd: 'رمز عبور جدید', 
 pwdage: 'تایید رمز عبور', 
 loginpwdplaceholder:'لطفا رمز عبور فعلی وارد کنید', 
 loginnewpwdplaceholder: 'لطفا رمز عبور جدید وارد کنید', 
 moneypwd: 'لطفا رمز عبور کشیدن وارد کنید', 
 pwdageplaceholder:'لطفا رمز عبور را دوباره وارد کنید' 
 }, 
 trade:{ 
 title: 'تبادل ارز دیجیتال', 
 price: 'قیمت', 
 num: 'تعداد', 
 entrust: 'سفارش فعلی', 
 clinch: 'معامله واقعی', 
 used: 'قابل استفاده', 
 buyed: 'قابل خرید', 
 amount: 'مبلغ', 
 limitprice: 'قیمت محدود', 
 marketprice: 'قیمت بازار', 
 forprice: 'با بهترین قیمت فعلی', 
 errorMoney: 'مبلغ قابل استفاده کافی نیست', 
 priceerror: 'لطفا قیمت سفارش وارد کنید', 
 numerror: 'لطفا تعداد سفارش وارد کنید', 
 moneyerror: 'لطفا مبلغ سفارش وارد کنید', 
 }, 
 assets:{ 
 allconvert:'مجموع دارایی ها', 
 usenum: 'قابل استفاده', 
 freeze: 'مسدود', 
 convert: 'مجموع', 
 tab1:'دارایی ها', 
 tab11: 'مجموع دارایی ها', 
 tab12: 'مجموع گزینه ها', 
 tab13: 'مجموع پول', 
 tab14: 'مجموع کوانت', 
 tab2:'گزینه ها', 
 tab21: 'حساب گزینه ها', 
 tab3:'پول', 
 tab31:'حساب پول', 
 tab4:'کوانت', 
 tab41:'حساب کوانت', 
 tbhead1: 'سوابق مالی', 
 tbhead2: 'سوابق کشیدن', 
 tbhead3: 'سوابق پر کردن', 
 tbhead4: 'سوابق انتقال', 
 rcdnum: 'تعداد', 
 rcd: 'سوابق', 
 rcdtime: 'زمان' , 
 rcdstatus: 'وضعیت', 
 rcddesc: 'توضیحات', 
 rcdaddress: 'نشانی پر کردن' 
 }, 
 change:{ 
 title: 'انتقال', 
 from: 'از {name}', 
 to: 'به {name}', 
 frmtitle: 'تعداد انتقال', 
 inputplaceholder: 'لطفا تعداد انتقال وارد کنید', 
 btntxt:'انتقال' 
 }, 
 recharge:{ 
 title: 'پر کردن', 
 bType: 'ارز فعلی', 
 address: 'نشانی پر کردن', 
 token: 'معامله گواهی', 
 tokenplaceholder: 'لطفا معامله گواهی آپلود کنید', 
 num: 'تعداد پر کردن', 
 numplaceholder: 'لطفا تعداد وارد کنید', 
 btn: 'ارسال به بررسی', 
 bankname: 'نام بانک', 
 bankno: 'شماره بانک', 
 accountname: 'نام حساب دریافت کننده', 
 bankaddress: 'آدرس بانک', 
 bankcode: 'کد انتقال بانک', 
 companyaddress: 'آدرس شرکت' 
 }, 
 withdrawal:{ 
 title:'کشیدن', 
 frmtitle1: 'تعداد', 
 frmplaceholder1: 'تعداد کشیدن باید در محدوده {min} تا {max} باشد', 
 frmtitle2: 'رمز عبور کشیدن', 
 frmplaceholder2: 'لطفا رمز عبور کشیدن وارد کنید', 
 getnum: 'تعداد دریافت شده', 
 fee:'هزینه', 
 btn: 'کشیدن' 
 }, 
 exchangeb:{ 
 title: 'تبادل', 
 account: 'حساب', 
 btn: 'تبادل', 
 numerror: 'لطفا تعداد تبادل وارد کنید' 
 }, 
 option:{ 
 title: 'گزینه ها', 
 typetitle: 'قرارداد ثانیه ای', 
 listtitle: 'پوزیشن', 
 kline: 'K خط', 
 high: 'بالا', 
 low: 'پایین', 
 nums: 'تعداد ۲۴ ساعت', 
 time: 'زمان', 
 transaction: 'روش تبادل', 
 quantity: 'تعداد افتتاح پوزیشن', 
 quantityerror: 'لطفا تعداد افتتاح پوزیشن وارد کنید', 
 times: 'زمان افتتاح پوزیشن', 
 times1: 'زمان تسویه حساب',
 account: 'موجودی حساب', 
 buyup:'خرید بالا', 
 buydown: 'خرید پایین', 
 tab1: 'لیست پوزیشن', 
 tab2: 'سوابق سفارش', 
 num: 'تعداد', 
 price1: 'قیمت خرید', 
 price2: 'قیمت فروش', 
 profitandloss: 'سود و زیان پیش بینی شده', 
 profitandloss1: 'سود و زیان', 
 countdown: 'بازمانده زمان', 
 waitfinish: 'در انتظار پایان', 
 finishing: 'در حال پایان...', 
 finished: 'پایان یافت', 
 order_price: 'قیمت فعلی', 
 order_cycle: 'چرخه', 
 order_type: 'نوع', 
 order_money: 'مبلغ', 
 order_time: 'افتتاح پوزیشن', 
 order_get: 'سود', 
 order_btn: 'سفارش بیشتر' 
 }, 
 tradelst:{ 
 title: 'سفارش های من', 
 tab1: 'سفارش', 
 tab2: 'معاملات انجام شده', 
 tab3: 'لغو شده', 
 usdtnum: '' 
 }, 
 loans:{ 
 title: 'وام کمک', 
 order_tab: 'سفارش های وام', 
 pro_tab: 'محصولات وام', 
 
 Institution:'موسسه وام دهنده', 
 Amount: 'مبلغ', 
 DailyInterest:'بهره روزانه', 
 RepaymentPeriod:'مدت بازپرداخت', 
 Application: 'درخواست وام', 
 orderno: 'شماره سفارش', 
 AllInterest: 'مجموع بهره', 
 RepaymentDate:'تاریخ بازپرداخت', 
 RepaymentMethod: 'روش بازپرداخت', 
 Onetime: 'یک بار', 
 Expected_loan_amount:'مبلغ وام مورد نیاز', 
 Expected_loan_amounterror:'مبلغ وام باید در محدوده {min} تا {max} باشد', 
 imgplaceholdr: 'وام اعتباری (لطفا اطمینان حاصل کنید که تصویر واضح و قابل مشاهده است)', 
 icon1: 'آپلود جناح جلو مدارک', 
 icon2: 'آپلود جناح عقب مدارک', 
 icon3: 'آپلود مدارک همراه با دست', 
 status1: 'در حال درخواست', 
 status2: 'درخواست پذیرفته شد', 
 status3: 'درخواست رد شد', 
 }, 
 lockming:{ 
 title: 'کان کردن قفل', 
 order_tab: 'سفارش ماشین معدن', 
 pro_tab: 'بازار ماشین معدن', 
 locknum: 'حداقل تعداد کان کردن قفل', 
 getforday: 'نرخ بازده/روز', 
 days: 'روز', 
 estimation: 'بازده تخمینی', 
 real: 'بازده واقعی', 
 balance: 'موجودی کیف پول', 
 nums: 'تعداد کان کردن قفل', 
 tolockming: 'کان کردن قفل', 
 stime: 'زمان شروع', 
 etime: 'زمان پایان', 
 }, 
 transfer:{ 
 title: 'انتقال حساب', 
 searchtxt: 'لطفا شماره حساب مقابل وارد کنید', 
 ReceivingAccount: 'اطلاعات حساب دریافت کننده', 
 toaccount: 'حساب', 
 confirmtxt: 'لطفا حساب دریافت کننده را تایید کنید', 
 confirmedtxt: 'حساب دریافت کننده تایید شد', 
 numtxt: 'تعداد انتقال', 
 numerror: 'لطفا تعداد انتقال وارد کنید', 
 fee: 'هزینه انتقال داخلی رایگان', 
 ArrivalTime: 'زمان ورود', 
 Immediately: 'فورا وارد شد', 
 realnum: 'تعداد واقعی وارد شده', 
 btn: 'تایید انتقال', 
 
 transfering: 'در حال انتقال', 
 orderNo: 'شماره سفارش', 
 stime: 'زمان انتقال', 
 etime: 'زمان ورود', 
 receiving: 'حساب دریافت کننده', 
 type: 'ارز', 
 num: 'تعداد انتقال', 
 arrivalnum: 'تعداد ورودی' 
 }, 
 staking:{ 
 title: 'رهن', 
 record: 'سوابق', 
 getforyear: 'سود سالانه مرجع', 
 time: 'مدت سرمایه گذاری', 
 snum: 'حداقل تعداد سرمایه گذاری', 
 snumerror: 'لطفا تعداد سرمایه گذاری وارد کنید', 
 snumerror1: 'تعداد سرمایه گذاری نباید کمتر از {num} باشد', 
 join: 'مشارکت فوری', 
 opentime: 'زمان افتتاح پوزیشن', 
 money: 'مبلغ سرمایه گذاری', 
 days: 'چرخه', 
 recordget: 'سود سالانه', 
 gets: 'سود', 
 stime: 'تاریخ شروع', 
 etiem: 'تاریخ پایان', 
 redeemStaking: 'انصراف', 
 status0: 'در حال رهن', 
 status1: 'سفارش پایان یافت', 
 status2: 'سفارش بازگشت داده شد', 
 }, 
 bank:{ 
 title: 'بند نشانی بانک', 
 bankName: 'نام بانک', 
 bankNameError: 'لطفا نام بانک وارد کنید', 
 usrName: 'نام کارت دار', 
 usrNameError: 'لطفا نام کارت دار وارد کنید', 
 cardCode: 'شماره کارت', 
 cardCodeError: 'لطفا شماره کارت وارد کنید', 
 towallet: 'کشیدن به کیف پول', 
 tobank: 'کشیدن به بانک', 
 sendcode: 'ارسال کد تایید', 
 sended: '{num} ثانیه دیگر برای ارسال مجدد', 
 verify_code: 'لطفا کد تایید ایمیل وارد کنید' 
 } 
}
